<!-- (commentary-drawer-close) catches the composed:true CustomEvent
  commentary-ui's own close (x) button dispatches from inside its Shadow
  DOM, routing it to the same close() the frame's own close button uses. -->
<div
  class="hs-cdf"
  [class.hs-cdf-docked]="!prefs.floating"
  [class.hs-cdf-floating]="prefs.floating"
  [class.hs-cdf-dragging]="isDragging"
  [class.hs-cdf-hidden]="!isOpen || !isRevealed || isMinimized"
  [style.width.px]="widthPx"
  [style.height]="heightStyle"
  [style.left.px]="leftPx"
  [style.top.px]="topPx"
  role="dialog"
  aria-label="Comments drawer"
  data-testid="comments-drawer-frame"
  [attr.data-mode]="prefs.floating ? 'floating' : 'docked'"
  (commentary-drawer-close)="close()"
>
  <div
    class="hs-cdf-titlebar"
    (mousedown)="beginDrag($event)"
    data-testid="comments-drawer-titlebar"
  >
    <!-- Empty: commentary-ui renders its own "Comments" title inside
      hs-comments-drawer below. Span stays as the flex-grow spacer that
      right-aligns the dock/close buttons. -->
    <span class="hs-cdf-title"></span>
    <!-- No close button here — commentary-ui's own titlebar close (x)
      already closes this frame via (commentary-drawer-close) above,
      so a second one here would just be a duplicate. -->
    <button
      type="button"
      class="hs-cdf-iconbtn"
      [attr.aria-label]="dockButtonLabel"
      [title]="dockButtonLabel"
      data-testid="comments-drawer-dock-toggle"
      (click)="toggleDock()"
    >
      <i class="mdi" [ngClass]="dockButtonIcon"></i>
    </button>
  </div>

  <div class="hs-cdf-body">
    <hs-comments-drawer
      [isVisible]="isOpen"
      [entityContext]="entityContext"
      [commentaryAction]="commentaryAction"
      [commentaryActionSeq]="commentaryActionSeq"
      [accountId]="accountId"
      [relatedAccountIds]="relatedAccountIds"
      [userId]="userId"
      [userDisplayName]="userDisplayName"
      [threadIds]="threadIds"
      [threadIdsSeq]="threadIdsSeq"
      [commentId]="commentId"
      (closePanel)="close()"
    ></hs-comments-drawer>
  </div>

  <div
    *ngIf="!prefs.floating && !isMinimized"
    class="hs-cdf-resize-handle hs-cdf-resize-left"
    role="separator"
    aria-orientation="vertical"
    aria-label="Resize comments drawer"
    data-testid="comments-drawer-resize-left"
    (mousedown)="beginResize('left', $event)"
  ></div>

  <div
    *ngIf="prefs.floating && !isMinimized"
    class="hs-cdf-resize-handle hs-cdf-resize-corner"
    role="separator"
    aria-label="Resize comments drawer"
    data-testid="comments-drawer-resize-corner"
    (mousedown)="beginResize('corner', $event)"
  ></div>
</div>
